// @ts-nocheck
import { parseXY } from 'xy-parser';
import { Analysis } from '../Analysis';
/**
 * Convert strings into JCAMP and add extra information
 * @param {string} data - values to add to the file, usually a csv or tsv values
 * @param {object} [options={}]
 * @param {string} [options.info={}] - metadata of the file
 * @param {string} [options.info.title = ''] - title of the file
 * @param {string} [options.info.dataType = ''] - type of data
 * @param {string} [options.info.xUnits = ''] - units for the x axis
 * @param {string} [options.info.yUnits = ''] - units for the y axis
 * @param {string} [options.info.xLabel = ''] - label for the x axis
 * @param {string} [options.info.yLabel = ''] - label for the y axis
 * @param {object} [options.meta = {}] - comments to add to the file
 * @param {object} [options.parser = {}] - 'xy-parser' options. arrayType = 'xyxy' is enforced
 * @return {string} JCAMP of the input
 */
export function fromText(data, options = {}) {
    let analysis = new Analysis(options);
    const { info = {}, parser = {} } = options;
    parser.keepInfo = true;
    let parsed = parseXY(data, parser);
    const variables = {
        x: {
            data: parsed.data.x,
            units: info.xUnits,
            label: info.xLabel,
        },
        y: {
            data: parsed.data.y,
            units: info.yUnits,
            label: info.yLabel,
        },
    };
    analysis.pushSpectrum(variables, options);
    return analysis;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZnJvbVRleHQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZnJvbS9mcm9tVGV4dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxjQUFjO0FBRWQsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLFdBQVcsQ0FBQztBQUVwQyxPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0sYUFBYSxDQUFDO0FBRXZDOzs7Ozs7Ozs7Ozs7OztHQWNHO0FBRUgsTUFBTSxVQUFVLFFBQVEsQ0FBQyxJQUEwQixFQUFFLE9BQU8sR0FBRyxFQUFFO0lBQy9ELElBQUksUUFBUSxHQUFHLElBQUksUUFBUSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0lBRXJDLE1BQU0sRUFBRSxJQUFJLEdBQUcsRUFBRSxFQUFFLE1BQU0sR0FBRyxFQUFFLEVBQUUsR0FBRyxPQUFPLENBQUM7SUFFM0MsTUFBTSxDQUFDLFFBQVEsR0FBRyxJQUFJLENBQUM7SUFDdkIsSUFBSSxNQUFNLEdBQUcsT0FBTyxDQUFDLElBQUksRUFBRSxNQUFNLENBQUMsQ0FBQztJQUNuQyxNQUFNLFNBQVMsR0FBRztRQUNoQixDQUFDLEVBQUU7WUFDRCxJQUFJLEVBQUUsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDO1lBQ25CLEtBQUssRUFBRSxJQUFJLENBQUMsTUFBTTtZQUNsQixLQUFLLEVBQUUsSUFBSSxDQUFDLE1BQU07U0FDbkI7UUFDRCxDQUFDLEVBQUU7WUFDRCxJQUFJLEVBQUUsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDO1lBQ25CLEtBQUssRUFBRSxJQUFJLENBQUMsTUFBTTtZQUNsQixLQUFLLEVBQUUsSUFBSSxDQUFDLE1BQU07U0FDbkI7S0FDRixDQUFDO0lBRUYsUUFBUSxDQUFDLFlBQVksQ0FBQyxTQUFTLEVBQUUsT0FBTyxDQUFDLENBQUM7SUFFMUMsT0FBTyxRQUFRLENBQUM7QUFDbEIsQ0FBQyJ9